import { cn } from "~/utils/helpers"

export default function HoverCardRow({
  icon,
  label,
  value,
  description,
  className,
  classNameWrapper,
  valueExtra,
}: {
  icon: React.ReactNode
  label: React.ReactNode
  value: React.ReactNode
  description?: string
  className?: string
  classNameWrapper?: string
  valueExtra?: React.ReactNode
}) {
  return (
    <div
      className={cn(
        // gap-4 keeps a wrapping description clear of the value column.
        "flex flex-1 items-center justify-between gap-4 paragraph-sm px-4 py-1.5 my-1.5",
        classNameWrapper,
      )}
    >
      <span
        className={cn("flex gap-2 text-fg-subtle", description ? "items-start" : "items-center")}
      >
        {icon != null && <span className={cn(description && "mt-0.5")}>{icon}</span>}
        {description ? (
          <span className="flex flex-col">
            <span>{label}</span>
            <span className="text-xs text-fg-muted leading-tight">{description}</span>
          </span>
        ) : (
          label
        )}
      </span>
      <span className={cn("font-medium text-fg-base shrink-0 flex items-center gap-1", className)}>
        {valueExtra}
        {value}
      </span>
    </div>
  )
}
